<div class="share-callback d-flex flex-column justify-content-center align-items-center vh-100">

  <!-- SUCCESS -->
  <ng-container *ngIf="status === 'linkedin_success'">
    <div class="callback-card card shadow-sm border-0 text-center p-4 p-md-5">

      <!-- Logo -->
      <div class="mb-4">
        <img src="assets/img/logo.png" alt="ShareWave" class="callback-logo">
      </div>

      <!-- Checkmark -->
      <div class="mb-4 d-flex justify-content-center">
        <div class="check-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
               fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
      </div>

      <!-- Message -->
      <p class="fw-semibold callback-title mb-4">
        ¡Tu credencial se compartió exitosamente!
      </p>

      <!-- Buttons -->
      <div class="d-flex flex-column gap-3">
        <button *ngIf="postUrl" (click)="goToPost()" [disabled]="btnPostDisabled"
           class="btn btn-sw-primary w-100">
          {{ btnPostDisabled ? 'Espere unos segundos...' : 'Ver en LinkedIn' }}
        </button>
        <p class="callback-small-text"><strong>Nota:</strong> Es posible que LinkedIn aún no muestre la publicación
          hasta después de unos segundos. Para ello, simplemente recargue la página.</p>
        <button (click)="redirectBack()" class="btn btn-sw-secondary w-100">
          Volver a tu credencial
        </button>
      </div>

    </div>
  </ng-container>

  <!-- ERROR -->
  <ng-container *ngIf="status === 'linkedin_error'">
    <div class="callback-card card shadow-sm border-0 text-center p-4 p-md-5">

      <!-- Logo -->
      <div class="mb-4">
        <img src="assets/img/logo.png" alt="ShareWave" class="callback-logo">
      </div>

      <!-- Error icon — círculo outline con X -->
      <div class="mb-4 d-flex justify-content-center">
        <div class="error-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24"
               fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>
      </div>

      <p class="fw-semibold mb-2 callback-title">
        No pudimos compartir tu credencial en LinkedIn.
      </p>

      <p *ngIf="errorMessage" class="text-muted mb-4 callback-small-text">
        <strong>Error:</strong> {{ errorMessage }}
      </p>
      <div *ngIf="!errorMessage" class="mb-4"></div>

      <button (click)="redirectBack()" class="btn btn-sw-primary w-100">
        Volver a tu credencial
      </button>

    </div>
  </ng-container>

  <!-- LOADING -->
  <ng-container *ngIf="!status">
    <div class="text-center">
      <div class="spinner-border sw-loader mb-3" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="text-muted">Cargando...</p>
    </div>
  </ng-container>

</div>
